class Expense {
    id = null;
    invoice = true;
    ag_fee = false;
    pay_slip = false;
    name = '';
    date = null;
    value = null;
    expense_status_id = 1;
    placement_id = null;
    currency_id = null;
    target_currency_id = null;
    exchange_rate = null;
    target_value = null;
    user_id = '';
    uploaded_files = [];
    expense_type_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Expense;
